<a
  target="_blank"
  href="https://www.facebook.com/dskbank"
  aria-label="Посети Фейсбук"
  i18n-aria-label
>
  <mat-icon svgIcon="facebook"></mat-icon>
</a>
<a
  target="_blank"
  href="https://www.linkedin.com/company/dsk-bank/"
  aria-label="Посети Линкедин"
  i18n-aria-label
>
  <mat-icon svgIcon="linkedin"></mat-icon>
</a>
<a
  target="_blank"
  href="https://www.youtube.com/channel/UCsHel4kfWjsoLit_09E8QOw"
  aria-label="Гледай в Ютюб"
  i18n-aria-label
>
  <mat-icon svgIcon="youtube"></mat-icon>
</a>
